export default "__VITE_ASSET__a8LT$Ovu__"